// Copyright (C) 2019 TANNER AG

import React, { useState } from "react";
import * as PropTypes from "prop-types";
import { Module } from "../module";
import { withStore } from "../../store/withstore";
import { TileButton } from "../../components/button";

const DrivingProfileButton = ({ name, value, setValue }) => (
	<TileButton
		onClick={() => setValue(name)}
		active={value === name}
	>
		{name}
	</TileButton>
);

const DrivingProfile = (props) => {
	const { store: { a }, storeAction } = props;
	const [value, setValue] = useState(a.drivingProfile || "");

	return (
		<Module
			id={props.id}
			activeModule={props.activeModule}
			nextModule={props.nextId}
			onActivate={props.setActiveModule}
			final={props.final}
			label="module.drivingprofile.title"
			title="module.drivingprofile.query"
			valueA={value}
			valueB={value}
			continueEnabled={Boolean(value)}
			onContinue={() => storeAction.setDrivingProfile(value)}
			queryA={(
				<React.Fragment>
					<DrivingProfileButton
						name="SORT 1"
						value={value}
						setValue={setValue}
					/>
					<DrivingProfileButton
						name="SORT 2"
						value={value}
						setValue={setValue}
					/>
					<DrivingProfileButton
						name="SORT 3"
						value={value}
						setValue={setValue}
					/>
				</React.Fragment>
			)}
		/>
	);
};

DrivingProfile.propTypes = {
	id: PropTypes.string.isRequired,
	nextId: PropTypes.string.isRequired,
	activeModule: PropTypes.string,
	setActiveModule: PropTypes.func
};

export default withStore(DrivingProfile);



// WEBPACK FOOTER //
// ./src/tco/configuration/modules/drivingprofile.js